// @vendors
import { put, takeLatest, call } from 'redux-saga/effects';
import get from 'lodash/get';

// @Services
import { doLogin, checkLogin, getRoles, doQRCODE, checkQRCode } from './auth.services';

// @Actions
import {
  REQUEST_FAILURE,
  REQUEST_FINISHED,
  REQUEST_STARTED,
} from '../app/app.actionTypes';
import {
  CHECK_AUTHENTICATION,
  LOGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_SUCCESS,
  SET_AUTHENTICATION,
  LOGIN_WAIT, CHECK_LOGIN,
  QR_CODE,
  SET_QR_CODE,
  CHECK_QR_CODE,
  CHECK_LOGIN_END,
  CHECK_LOGIN_START
} from './auth.actionTypes';

// @Utils
import {
  buildErrorsObj,
  getAuthorizationToken,
    getSessionId,
  getUserLogged,
  signIn,
  signOut,
} from '../../utils/auth';

const hooliCod = ['HGATE', 'AAD', 'AUS', 'ACO', 'ABC']

function* getQRCode ({payload})  { 
  try {
    yield put({ type: REQUEST_STARTED });
    const data = { 
      sesionLatitud: payload.lat, 
      sesionLongitud: payload.lng
    }
    const response = yield call(doQRCODE, data)
    const status = get(response, 'data.status.code', null);
    const dataResponse =  get(response, 'data.result[0]', null);
    console.log("Data", dataResponse)
    if(status === 1){   
      yield put({
        type: SET_QR_CODE,
        payload: {
          qrCode: dataResponse.codigoQR
        }
    })
  }
    if (get(response, 'data.status.errcode', null)) {
      yield put({
        type: LOGIN_FAILURE,
        payload: {
          authenticatedErrorMessage: get(response, 'data.status.errmsg', '')
        }
      });
    } else {
      const data = get(response, 'data.status.errmsg', '');

      yield put({
        type: LOGIN_WAIT,
        payload: {
          webToken: data
        }
      })
    }
  }catch(err){ 

  }
}



function* loginWorker({ payload }) {
  try {
    yield put({ type: REQUEST_STARTED });

    const response = yield call(doLogin, payload.data);

    if (get(response, 'data.status.errcode', null)) {
      yield put({
        type: LOGIN_FAILURE,
        payload: {
          authenticatedErrorMessage: get(response, 'data.status.errmsg', '')
        }
      });
    } else {
      const data = get(response, 'data.status.errmsg', '');

      yield put({
        type: LOGIN_WAIT,
        payload: {
          webToken: data
        }
      })
    }


    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: LOGIN_FAILURE,
      payload: {
        authenticatedErrorMessage: err
      }
    });
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}


  function* checkLoginWorker({ payload }) {
    try {
      yield put({ type: CHECK_LOGIN_START });
      yield put({ type: REQUEST_STARTED });
  
      const response = yield call(checkQRCode, payload.qrCode);
  
      const status = get(response, 'data.status.code', null);
      const data = get(response, 'data.result[0]', null);
      console.log("Payload en check login", payload)
      if (status === 0) { 
        yield put({
          type: REQUEST_FAILURE,
          payload: {
            serverErrors: 'Se ha excedido el tiempo de verificación de identidad. Reintente.',
            statusError: '401'
          }
        });
      } else if (status === 1) {
        
        signIn(data);
        const rolesResponse = yield call(getRoles);
  
        const roles = get(rolesResponse, 'data.result', []);
  
        data.roles = roles;
  
        signIn(data);
  
        if (roles.length === 1) {
          if(!hooliCod.includes(roles[0].servicioHooliCod)) return
          const url = new URL(process.env[`REACT_APP_${roles[0].servicioHooliCod}_URL`])
          url.searchParams.append("session", getSessionId())
          url.searchParams.append("token", getAuthorizationToken())
          url.searchParams.append("latitud", payload.lat)
          url.searchParams.append("longitud", payload.lng)
          roles[0].servicioHooliCod === "HGATE" && url.searchParams.append("merchantId", roles[0].merchantId)
          window.location = url.href
          
        }else {
          yield put({
            type: LOGIN_SUCCESS,
            payload: {
              isAuthenticated: true,
              userLogged: {
                usuarioApellidos: get(data, 'usuarioApellidos', ''),
                usuarioNombres: get(data, 'usuarioNombres', ''),
                usuarioId: get(data, 'usuarioId', ''),
                roles: roles,
                latitud: payload.lat,
                longitud: payload.lng
              }
            }
          });
        }
      }
  
      yield put({ type: REQUEST_FINISHED });
      yield put({ type: CHECK_LOGIN_END });
    } catch (err) {
      yield put({
        type: LOGIN_FAILURE,
        payload: {
          authenticatedErrorMessage: 'Los servicios de hooli no estan disponibles'
        }
      });
      yield put({
        type: REQUEST_FAILURE,
        payload: buildErrorsObj(err)
      });
      yield put({ type: CHECK_LOGIN_END });
    }
  }
  

function* checkAuthenticationWorker() {
  try {
    yield put({ type: REQUEST_STARTED });
    console.log("Esto es get auth", getAuthorizationToken())
    if (getAuthorizationToken()) {
      const data = getUserLogged();
      yield put({
        type: LOGIN_SUCCESS,
        payload: {
          userLogged: data,
          isAuthenticated: true
        }
      });
    } else {
      yield put({
        type: SET_AUTHENTICATION,
        payload: {
          userLogged: {},
          isAuthenticated: false
        }
      });
    }

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* logoutWorker() {
  try {
    yield put({ type: REQUEST_STARTED });

    // yield call(doLogout);

    signOut();

    yield put({ type: LOGOUT_SUCCESS });

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* requestWatcher() {
   yield takeLatest(LOGIN, loginWorker);
   yield takeLatest(CHECK_LOGIN, checkLoginWorker);
   yield takeLatest(CHECK_AUTHENTICATION, checkAuthenticationWorker);
   yield takeLatest(LOGOUT, logoutWorker);
   yield takeLatest (QR_CODE, getQRCode);
  
}

export default { requestWatcher };



// WEBPACK FOOTER //
// ./src/state/auth/auth.sagas.js